import React from 'react';

import ProfileImage from '@buyside/components/presentation/ProfileImage/profileImage';
import Link from '@buyside/components/presentation/Link/link';
import FundUpdateMarketingMaterials from '@buyside/components/presentation/Feed/FundUpdate/FundUpdateMarketingMaterials/fundUpdateMarketingMaterials';
import FundUpdatePressMediaList from '@buyside/components/presentation/Feed/FundUpdate/FundUpdatePressMediaList/fundUpdatePressMediaList';
import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';

import BriefcaseIcon from '@buyside/svgs/briefcase.svg';

import { employerProfileVanityUrl } from '@buyside/util/urlHelper';
import { ActivityFeedEmployerProfileUpdateFragment } from '@interfaces/graphql-typings';
import { FeedItemComponentType } from '@interfaces/feed/feedItems';

import styles from './fundUpdateStyles.scss';

const FundUpdate: React.FC<{
  fundUpdate: ActivityFeedEmployerProfileUpdateFragment;
} & FeedItemComponentType> = ({ fundUpdate }): React.ReactElement => {
  const marketingMaterials = fundUpdate.marketingMaterials;
  const pressMediaList = fundUpdate.pressMediaList;
  const vanityLink = fundUpdate.fundProfile?.vanityLink;

  return (
    <div className={styles.fundUpdate}>
      <header className={styles.fundUpdateHeader}>
        <ProfileImage
          source={fundUpdate?.fundProfile?.logoProfileUrl}
          shape="square"
          size="small"
        />
        {vanityLink && (
          <span className={styles.fundUpdateHeaderText}>
            <Link to={employerProfileVanityUrl(vanityLink)}>{fundUpdate?.fundProfile?.name}</Link>{' '}
            updated its fund profile
          </span>
        )}
      </header>
      <ul>
        {fundUpdate.expertiseChanges && <li>Added new expertise</li>}
        {fundUpdate.fundReturnsChanges && <li>Posted updated returns</li>}
        {fundUpdate.fundHoldingsChanges && <li>Modified its fund holdings</li>}
        {marketingMaterials?.edges && marketingMaterials?.edges.length > 0 && (
          <li>
            Added Marketing Materials / Investor Communications:
            <FundUpdateMarketingMaterials marketingMaterials={marketingMaterials} />
          </li>
        )}
        {pressMediaList?.edges && pressMediaList?.edges.length > 0 && (
          <li>
            Added Press/Media Items:
            <FundUpdatePressMediaList list={pressMediaList} vanityLink={vanityLink} />
          </li>
        )}
      </ul>
      <div className={styles.buttonWrap}>
        {vanityLink && (
          <Button
            icon={BriefcaseIcon}
            type={BUTTON_TYPES.PRIMARY}
            text="View Fund"
            url={employerProfileVanityUrl(vanityLink)}
          />
        )}
      </div>
    </div>
  );
};

export default FundUpdate;
